import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.outstanding_view.amountToRepayBeforeTopupEligibleTitle',
        defaultMessage: 'Request more funds'
    },
    description: {
        id: '_.outstanding_view.amountToRepayBeforeTopupEligible',
        defaultMessage:
            'You’ll become eligible to request more funds once you’ve repaid <strong>{amountToRepayBeforeTopUp}</strong> – approval is subject to credit review'
    }
});
